import * as fromDatatype from "../datatype-library/index";

export interface bl_svc_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_location: fromDatatype.VarcharDatatypeInterface;
  client_guid: fromDatatype.GuidDataFieldInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  doc_level: fromDatatype.IntegerDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  doc_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_line_json: fromDatatype.JsonDatatypeInterface;
  status_client: fromDatatype.StatusDataFieldInterface;
  status_server: fromDatatype.StatusDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  display_entity_guid: fromDatatype.GuidDataFieldInterface;
  delivery_entity_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  device_guid: fromDatatype.GuidDataFieldInterface;
  reseller_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  reseller_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  track_production_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
  track_delivery_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_gst_balance: fromDatatype.MoneyDatatypeInterface;
  amount_wht_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  doc_reference: fromDatatype.TextDatatypeInterface;
  doc_desc: fromDatatype.TextDatatypeInterface;
  doc_remarks: fromDatatype.TextDatatypeInterface;
  property_json: any;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  billing_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  external_do_no: fromDatatype.VarcharDatatypeInterface;
  external_svc_note_no: fromDatatype.VarcharDatatypeInterface;
}

export class bl_svc_doc_hdr_RowClass
  implements bl_svc_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  doc_source_type: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.GuidDataFieldInterface;
  app_id: fromDatatype.GuidDataFieldInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_location: fromDatatype.VarcharDatatypeInterface;
  client_guid: fromDatatype.GuidDataFieldInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  doc_level: fromDatatype.IntegerDatatypeInterface;
  doc_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_hdr_json: fromDatatype.JsonDatatypeInterface;
  doc_entity_line_guid: fromDatatype.GuidDataFieldInterface;
  doc_entity_line_json: fromDatatype.JsonDatatypeInterface;
  status_client: fromDatatype.StatusDataFieldInterface;
  status_server: fromDatatype.StatusDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  display_entity_guid: fromDatatype.GuidDataFieldInterface;
  delivery_entity_guid: fromDatatype.GuidDataFieldInterface;
  contact_key_guid: fromDatatype.GuidDataFieldInterface;
  member_guid: fromDatatype.GuidDataFieldInterface;
  contact_hdr_guid: fromDatatype.GuidDataFieldInterface;
  device_guid: fromDatatype.GuidDataFieldInterface;
  reseller_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  reseller_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_member_hdr_guid: fromDatatype.GuidDataFieldInterface;
  track_production_guid: fromDatatype.GuidDataFieldInterface;
  del_region_hdr_guid: fromDatatype.GuidDataFieldInterface;
  track_delivery_guid: fromDatatype.GuidDataFieldInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_2: fromDatatype.VarcharDatatypeInterface;
  server_doc_3: fromDatatype.VarcharDatatypeInterface;
  server_doc_4: fromDatatype.VarcharDatatypeInterface;
  server_doc_5: fromDatatype.VarcharDatatypeInterface;
  client_doc_1: fromDatatype.VarcharDatatypeInterface;
  client_doc_2: fromDatatype.VarcharDatatypeInterface;
  client_doc_3: fromDatatype.VarcharDatatypeInterface;
  client_doc_4: fromDatatype.VarcharDatatypeInterface;
  client_doc_5: fromDatatype.VarcharDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_gst_balance: fromDatatype.MoneyDatatypeInterface;
  amount_wht_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  doc_reference: fromDatatype.TextDatatypeInterface;
  doc_desc: fromDatatype.TextDatatypeInterface;
  doc_remarks: fromDatatype.TextDatatypeInterface;
  property_json: any;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  billing_json: fromDatatype.JsonDatatypeInterface;
  log_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  process: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  external_do_no: fromDatatype.VarcharDatatypeInterface;
  external_svc_note_no: fromDatatype.VarcharDatatypeInterface;
}
